<template lang="pug">
	div
		router-view.container-fluid
</template>

<script>
export default {
	data () {
		return {
		}
	},
	created () {
		const menu = [
			{
				'icono': 'fa fa-money',
				'nombre': 'Recibos',
				activo: (this.$route.path.split('/').splice(-1)[0] === 'cobros'),
				'callback': (a) => {
					this.$store.commit('top/setMenuActivo', a)
					this.$router.push('/main/cobros/cobros')
				}
			},
			{
				'icono': 'fa fa-plus-circle',
				'nombre': 'Comisiones',
				activo: (this.$route.path.split('/').splice(-1)[0] === 'comisiones'),
				'callback': (a) => {
					this.$router.push('/main/cobros/comisiones')
					this.$store.commit('top/setMenuActivo', a)
				}
			}
		]

		this.$store.commit('top/setMenu', menu)
	},
	beforeDestroy () {
		this.$store.commit('top/setMenu', [])
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/facturacion-cobros/vue/App.vue